<div class="sso-wrapper">
  <div class="sso-login-failure-container">
    <div class="sso-login-failure__content">
      <h1 class="sso-login-failure__title" [translate]="'LoginFormComponent:SsoLoginFailureHeader'">Login Failed</h1>
      <p class="sso-login-failure__message" [translate]="'LoginFormComponent:SsoLoginFailureBody'">
        There seems to be a problem. Please contact Credit Saison.
      </p>
    </div>
  </div>
</div>
